import i18n from '../../../../../i18n';
import store from '../../../../../store/index';

const exactMath = require('exact-math');

import { defineAsyncComponent, watch } from 'vue';
import { Form, Input, Modal } from 'ant-design-vue';
import lodash from 'lodash';
export const { isLoading, setIsLoading } = createLoading();
import { addRules, clearRulesStartsWith, required } from '../../../../../utils/validate';


import {
    createManageDelete, createManageExportCsv, createPage
} from '../../../../../utils/page';
import {
    onClickDeleteAllClient
} from '../../../../../utils/form';
import { has } from '../../../../../utils/menu-context';
import { openModalList as openModalListTopic } from '../../../master-mgt/lab/topic/topic-list.logic';
import {
    createButtonCreate
} from '../../../../../utils/button';
import { onIFrameClickSelectAll } from '../../../../../utils/iframe';

import {
    createColumnInlineRadioGroup, createColumnInlineSelect,
    createColumnInputNumber,
    createColumnSelect
} from '../../../../../components/table/c-table.logic';

export const CIcon = defineAsyncComponent(() => import('../../../../../components/icon/CIcon'));
const CInputNumber = defineAsyncComponent(() => import('../../../../../components/input/template-builder/input-number/InputNumber'));
const CSelect = defineAsyncComponent(() => import('../../../../../components/input/template-builder/select/CSelect'));


export const routerPrefix = 'lab-physic-sampling-product-analysis-exports';
import { callAcceptStatus } from '../physical-analysis/physical-analysis.logic';
import { createLoading } from '../../../../../utils/loading';

export const callLabTopic = ({ searchQuery, labTypeKey, where }) => store.dispatch('resource/v1/master/labTopic/cacheFindAll', {
    searchQuery,
    labTypeKey,
    where
});
export const callSearch = ({ criteria, actionPrefix }) => store.dispatch(`${actionPrefix}/search`, { criteria });


// export const checkNum = (value) => {
//     if (typeof value == "number" && !isNaN(value)) {
//         return true;
//     } else {
//         return false
//     }
// }

export const calOWithLib = ({ record }) => {
    let O = null;
    const CH = parseFloat(record.coverHook);
    const BH = parseFloat(record.bodyHook);
    const Te = parseFloat(record.thicknessEnd);
    const W = parseFloat(record.seamLength);
    if (isNaN(CH) || isNaN(BH) || isNaN(Te) || isNaN(W)) {
        return O;
    } else {
        const formularStr = `(${CH} + ${BH} + 1.1 * ${Te}) - ${W}`;
        O = exactMath.formula(formularStr);
        return O;
    }
};

export const calOverlapPercentageWithLib = ({ record }) => {
    const O = parseFloat(calOWithLib({ record }));
    const Tb = parseFloat(record.thicknessBody);
    const Te = parseFloat(record.thicknessEnd);
    const W = parseFloat(record.seamLength);
    let percentOverlap = null;
    if (isNaN(O) || isNaN(Te) || isNaN(Tb) || isNaN(W)) {
        return percentOverlap;
    } else {
        if (O != 0) {
            const formularStr = `(${O}/(${W} - 1.1 * ( 2 * ${Te} + ${Tb}))) * 100`;
            percentOverlap = exactMath.formula(formularStr);
        }
        return exactMath.round(percentOverlap, -2, { returnString: true, trim: false });
    }
};


/*
export const updateTableTopicInput = ({ props, fieldKey, value, acceptStatus, itemsKey }) => {
    props.parent[`${itemsKey}`].forEach(record => {
        record[fieldKey] = value;
        record.isSave = true;
        setAllCalInput({ record });
        setInputAccept({ record, modelRef: props?.useForm?.modelRef, itemsKey, acceptStatus });
    });
};
*/


/*export const createFields = ({ props, data }) => {
    const { itemsKey, acceptStatus } =  props;
    return [
        createFieldInputNumber({
                key: 'thicknessEnd',
                colProp: () => ({ xs: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessEnd'),
                inputProp: () => ({
                    value: data.thicknessEnd,
                    'onUpdate:value': value => {
                        data.thicknessEnd = value;
                        updateTableTopicInput({ props, fieldKey: 'thicknessEnd',  value, itemsKey, acceptStatus })
                    },
                    comma: false,
                    allowPrecision: true,
                })
            }),
            createFieldInputNumber({
                key: 'thicknessBody',
                colProp: () => ({ xs: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessBody'),
                inputProp: () => ({
                    value: data.thicknessBody,
                    'onUpdate:value': value => {
                        data.thicknessBody = value;
                        updateTableTopicInput({ props, fieldKey: 'thicknessBody', value, itemsKey, acceptStatus })
                    },
                    comma: false,
                    allowPrecision: true
                })
            }),
            createFieldInputNumber({
                key: 'seamThickness',
                colProp: () => ({ xs: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.samplingProductAnalysisTopicInput.seamThickness'),
                inputProp: () => ({
                    value: data.seamThickness,
                    'onUpdate:value': value => {
                        data.seamThickness = value;
                        updateTableTopicInput({ props, fieldKey: 'seamThickness', value, itemsKey, acceptStatus })
                    },
                    comma: false,
                    allowPrecision: true
                })
            }),
    ]
}*/
export const calFreeSpaceWithLib = ({ record }) => {
    const S = parseFloat(record.seamThickness);
    const Tb = parseFloat(record.thicknessBody);
    const Te = parseFloat(record.thicknessEnd);
    let freeSpace = null;
    if (isNaN(S) || isNaN(Tb) || isNaN(Te)) {
        return freeSpace;
    }
    else {
        const formularStr = `${S} - (2 * ${Tb} + 3 * ${Te})`;
        freeSpace = exactMath.formula(formularStr);
        return exactMath.round(freeSpace, -2, { returnString: true, trim: false });
    }

};

export const calBodyHookPercentageWithLib = ({ record }) => {
    const BH = parseFloat(record.bodyHook);
    const W = parseFloat(record.seamLength);
    const Tb = parseFloat(record.thicknessBody);
    const Te = parseFloat(record.thicknessEnd);
    let percentBodyHookButting = null;
    if (isNaN(BH) || isNaN(W) || isNaN(Tb) || isNaN(Te) || Te == 0) {
        return percentBodyHookButting;
    } else {
        const formulaDividendStr = `${BH} - 1.1 * ${Tb}`;
        const formulaDividerStr = `${W} - 1.1 * (2 * ${Te} + ${Tb})`;
        const dividend = exactMath.formula(formulaDividendStr);
        const divider = exactMath.formula(formulaDividerStr);
        if (divider != 0) {
            const formulaStr = `${dividend} / ${divider} * 100`;
            percentBodyHookButting = exactMath.formula(formulaStr);
        }
        return exactMath.round(percentBodyHookButting, -2, { returnString: true, trim: false });
    }
};

export const calCompactnessPercentageWithLib = ({ record }) => {
    const Tb = parseFloat(record.thicknessBody);
    const Te = parseFloat(record.thicknessEnd);
    const S = parseFloat(record.seamThickness);
    let percentCompactness = null;
    if (isNaN(S) || S == 0 || isNaN(Tb) || isNaN(Te)) {
        return percentCompactness;
    } else {
        const dividendFormularStr = `2 * ${Tb} + 3 * ${Te}`;
        const dividend = exactMath.formula(dividendFormularStr);
        const divider = S;
        if (divider != 0) {
            percentCompactness = exactMath.formula(`${dividend} / ${divider} * 100`);
        }
        return exactMath.round(percentCompactness, -2, { returnString: true, trim: false });
    }
};

export const calInputAccept = ({ record, acceptStatus }) => {
    if (isNaN(parseFloat(record.percentCompactness)) || isNaN(parseFloat(record.percentOverlap)) || isNaN(parseFloat(record.percentBodyHookButting))) {
        return null;
    } else if (record.percentCompactness >= 75 && record.percentOverlap >= 45 && record.percentBodyHookButting >= 70) {
        return acceptStatus.filter(it => it.key == 'Accept')[0];
    } else if (record.percentCompactness < 75) {
        return acceptStatus.filter(it => it.key == 'Reject')[0];
    } else if (record.percentOverlap < 25) {
        return acceptStatus.filter(it => it.key == 'Reject')[0];
    } else {
        return null;
    }
};

export const setInputAccept = ({ record, modelRef, itemsKey, acceptStatus }) => {
    record.refAcceptanceStatus = calInputAccept({ record, acceptStatus });
    record.isSave = true;
    checkAllInputPass({ modelRef, itemsKey, acceptStatus });
};

export const checkAllInputPass = ({ modelRef, itemsKey, acceptStatus }) => {
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const activeRecord = items.filter(d => d.isDelete !== true);
    const checkAllInputPass = activeRecord.map(d => d.refAcceptanceStatus?.key).every(key => key == 'Accept');
    if (checkAllInputPass) {
        modelRef.refTopicAnalysisStatus = acceptStatus?.filter(it => it.key == 'Accept')[0];
    } else {
        modelRef.refTopicAnalysisStatus = acceptStatus?.filter(it => it.key == 'Reject')[0];
    }
};

export const checkAllChildrenPass = ({ modelRef, itemsKey, acceptStatus }) => {
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const activeRecord = items.filter(d => d.isDelete !== true);
    const checkAllChildrenPass = activeRecord.map(d => d.refTopicAnalysisStatus?.key).every(key => key == 'Accept');
    if (checkAllChildrenPass) {
        modelRef.refTopicAnalysisStatus = acceptStatus?.filter(it => it.key == 'Accept')[0];
    } else {
        modelRef.refTopicAnalysisStatus = acceptStatus?.filter(it => it.key == 'Reject')[0];
    }
};

export const setAllCalInput = ({ record }) => {
    record.freeSpace = calFreeSpaceWithLib({ record });
    record.percentBodyHookButting = calBodyHookPercentageWithLib({ record });
    record.percentOverlap = calOverlapPercentageWithLib({ record });
    record.percentCompactness = calCompactnessPercentageWithLib({ record });
};

export const createColumns = ({ props, data }) => {
    const { itemsKey, viewOnly, useForm, acceptStatus } = props;
    const { modelRef } = useForm;
    let columns = [];
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    if (modelRef.refLabTopic?.refLabFormula?.key == 'Acceptance') {
        const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
        columns = [
            createColumnInlineSelect({
                title: () => i18n.global.t('model.samplingProductAnalysisTopic.refLabTopic'),
                dataIndex: 'refLabTopic',
                items,
                useForm,
                itemsKey,
                inputProp: () => ({
                    list: ({ searchQuery }) => {
                        const where = [{
                            name: 'refParent.id',
                            operator: '=',
                            type: 'UUID',
                            value: modelRef.refLabTopic.id
                        }];
                        return callLabTopic({ searchQuery, labTypeKey: 'labPhysic', where });
                    }
                }),
                customRenderInputProp: () => ({
                    disabled: viewOnly, list: ({ searchQuery }) => {
                        const where = [{
                            name: 'refParent.id',
                            operator: '=',
                            type: 'UUID',
                            value: modelRef.refLabTopic.id
                        }];
                        return callLabTopic({ searchQuery, labTypeKey: 'labPhysic', where });
                    }
                })
            }),
            createColumnInlineRadioGroup({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.refAcceptanceStatus'),
                dataIndex: `refTopicAnalysisStatus`,
                items,
                useForm,
                itemsKey,
                inputProp: () => ({
                    list: callAcceptStatus, optLabel: 'value'
                }),
                customRenderInputProp: ({ record }) => ({
                    disabled: viewOnly,
                    list: ({ searchQuery }) => callAcceptStatus({ searchQuery }).then(arr => arr.filter(it => it.key != 'RejectCanRepeat')),
                    optLabel: 'value',
                    'onUpdate:value': (value) => {
                        record.isSave = true;
                        record.refTopicAnalysisStatus = value;
                        checkAllChildrenPass({ modelRef, itemsKey, acceptStatus });
                    }
                })
            })
        ];
    } else if (modelRef.refLabTopic?.refLabFormula?.key == 'Integrity') {
        columns = [
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.point'),
                dataIndex: 'point',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.point`]} wrapperCol={{ xs: 24 }}>
                        <Input
                            value={record.point}
                            onUpdate:value={value => {
                                record.point = value;
                                record.isSave = true;
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.point')}
                        ></Input>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.countersinkDepth'),
                dataIndex: 'countersinkDepth',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.countersinkDepth`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.countersinkDepth}
                            onUpdate:value={value => {
                                record.countersinkDepth = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({
                                    record,
                                    modelRef,
                                    itemsKey,
                                    acceptStatus: props.parentData?.acceptStatus
                                });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.countersinkDepth')}
                            allowPrecision={true}
                            comma={false}

                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessEnd'),
                dataIndex: 'thicknessEnd',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.thicknessEnd`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.thicknessEnd}
                            onUpdate:value={value => {
                                record.thicknessEnd = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessEnd')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessBody'),
                dataIndex: 'thicknessBody',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.thicknessBody`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.thicknessBody}
                            onUpdate:value={value => {
                                record.thicknessBody = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.thicknessBody')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.seamThickness'),
                dataIndex: 'seamThickness',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.seamThickness`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.seamThickness}
                            onUpdate:value={value => {
                                record.seamThickness = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.seamThickness')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.seamLength'),
                dataIndex: 'seamLength',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.seamLength`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.seamLength}
                            onUpdate:value={value => {
                                record.seamLength = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.seamLength')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.coverHook'),
                dataIndex: 'coverHook',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.coverHook`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.coverHook}
                            onUpdate:value={value => {
                                record.coverHook = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.coverHook')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.bodyHook'),
                dataIndex: 'bodyHook',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.bodyHook`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.bodyHook}
                            onUpdate:value={value => {
                                record.bodyHook = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.bodyHook')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.percentTightness'),
                dataIndex: 'percentTightness',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.percentTightness`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.percentTightness}
                            onUpdate:value={value => {
                                record.percentTightness = value;
                                record.isSave = true;
                                setAllCalInput({ record });
                                setInputAccept({ record, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.percentTightness')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.freeSpace'),
                dataIndex: 'freeSpace',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.freeSpace`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            value={record.freeSpace}
                            disabled={true}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.freeSpace')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.percentBodyHookButting'),
                dataIndex: 'percentBodyHookButting',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const inputClass = record?.percentBodyHookButting < 70 ? 'input-number disabled bg-warning' : '';
                    const index = items.findIndex(d => d === record);
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.percentBodyHookButting`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            disabled={true}
                            class={record.percentBodyHookButting ? inputClass : ''}
                            value={record.percentBodyHookButting}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.percentBodyHookButting')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.percentOverlap'),
                dataIndex: 'percentOverlap',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    const inputClass = record?.percentOverlap < 25 ? 'input-number disabled bg-danger' : record?.percentOverlap <= 45 ? 'input-number disabled bg-warning' : '';
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.percentOverlap`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            disabled={true}
                            class={record.percentOverlap ? inputClass : ''}
                            value={record.percentOverlap}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.percentOverlap')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnInputNumber({
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.percentCompactness'),
                dataIndex: 'percentCompactness',
                width: 30,
                comma: false,
                inputProp: () => ({ comma: false, maxDecimal: 2 }),
                customRender: ({ record }) => {
                    const index = items.findIndex(d => d === record);
                    const inputClass = record?.percentCompactness > 75 ? 'input-number disabled bg-danger' : '';
                    return <Form.Item {...useForm.validateInfos[`${itemsKey}.${index}.percentCompactness`]}
                                      wrapperCol={{ xs: 24 }}>
                        <CInputNumber
                            disabled={true}
                            class={record.percentCompactness ? inputClass : ''}
                            value={record.percentCompactness}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.percentCompactness')}
                            allowPrecision={true}
                            comma={false}
                        ></CInputNumber>
                    </Form.Item>;
                }
            }),
            createColumnSelect({
                search: {
                    visible: () => false
                },
                dataIndex: 'refAcceptanceStatus.value',
                width: 30,
                title: () => i18n.global.t('model.samplingProductAnalysisTopicInputCountryResult.refResultStatus'),
                inputProp: () => ({ list: callAcceptStatus, optLabel: 'value' }),
                customRender: ({ record }) => {
                    return <Form.Item wrapperCol={{ xs: 24 }}>
                        <CSelect value={record.refAcceptanceStatus}
                                 onUpdate:value={(value) => {
                                     record.refAcceptanceStatus = value;
                                     checkAllInputPass({ data, modelRef, itemsKey, acceptStatus: props.acceptStatus });
                                 }}
                                 list={({ searchQuery }) => callAcceptStatus({ searchQuery }).then(arr => arr.filter(it => it.key != 'RejectCanRepeat'))}
                                 optLabel='value'
                        />
                    </Form.Item>;
                }
            })
        ];
    }
    return columns;
};


export const createFormAnalysisTopicInput = ({ parent, useForm, itemsKey }) => {
    const addForm = {
        countersinkDepth: null,
        // thicknessEnd:  parent.thicknessEnd,
        // thicknessBody:  parent.thicknessBody,
        // seamThickness: parent.seamThickness,
        thicknessEnd:  null,
        thicknessBody:  null,
        seamThickness: null,
        seamLength: null,
        coverHook: null,
        bodyHook: null,
        freeSpace: null,
        percentTightness: null,
        percentBodyHookButting: null,
        percentOverlap: null,
        percentCompactness: null,
        refAcceptanceStatus: null,
        refTopicAnalysisStatus: null
    };
    parent[`${itemsKey}`].push(addForm);
    createRulesAnalysisTopicInput({ useForm, itemsKey });
};

export const createRulesAnalysisTopicInput = ({ useForm, itemsKey }) => {
    const { modelRef } = useForm;
    const model = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    clearRulesStartsWith({ useForm, key: `${itemsKey}` });
    model?.forEach((input, index) => {
        if (modelRef.refLabTopic?.refLabFormula?.key == 'Integrity') {
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.point`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.countersinkDepth`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.thicknessEnd`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.thicknessBody`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.seamThickness`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.seamLength`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.coverHook`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.bodyHook`, rules: [required] });
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.percentTightness`, rules: [required] });
        }
        else if (modelRef.refLabTopic?.refLabFormula?.key == 'Acceptance') {
            addRules({ useForm, modelRef, key: `${itemsKey}.${index}.refTopicAnalysisStatus`, rules: [required] });
        }
    });
};

export const fetchData = ({ props }) => {
    const { fetchCriteria, actionPrefix } = props;
    if (!fetchCriteria) {
        return Promise.resolve({ data: [] });
    }
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria, actionPrefix }).finally(() => {
        setIsLoading(false);
    });
};


export const initData = ({ data, props, emit }) => {
    const { parent, root, menuContext, useForm, itemsKey, acceptStatus } = props;
    const { modelRef } = useForm;
    watch(
        () => modelRef[`${itemsKey}`].filter(d => d.isDelete !== true).length,
        () => {
            const activeItems = modelRef[`${itemsKey}`].filter(d => d.isDelete !== true);
            if (activeItems.length == 0) {
                modelRef.refTopicAnalysisStatus = null;
            } else {
                if (itemsKey == 'children') {
                    checkAllChildrenPass({ modelRef, itemsKey, acceptStatus });
                } else if (itemsKey == 'inputs') {
                    checkAllInputPass({ data, modelRef, itemsKey, acceptStatus });
                }
            }
        }
    );
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: parent[`${itemsKey}`] });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, items: parent.samplingProducts })
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];
    data.rowActionWidth = 30;
    data.manageExtras.push({
        render: () => ({
            ...createButtonCreate({
                onClick: () => {
                    if (modelRef.refLabTopic?.refLabFormula?.key == 'Integrity') {
                        createFormAnalysisTopicInput({ parent, root, useForm, itemsKey });
                    } else if (modelRef.refLabTopic?.refLabFormula?.key == 'Acceptance') {
                        openModalListTopic({
                            onIframeMounted: ({ refs, options }) => {
                                onIFrameClickSelectAll({
                                    refs,
                                    options,
                                    items: modelRef.children,
                                    itemKey: 'refLabTopic.id',
                                    rowKey: 'id',
                                    setKey: 'refLabTopic',
                                    onSearch: ({ whereAll }) => {
                                        const value = modelRef.children.filter(d => d.isDelete !== true).map(d => lodash.get(d, 'refLabTopic.id'));
                                        if (value.length > 0) {
                                            whereAll.push({ name: 'id', type: 'UUID', operator: '!in', value });
                                        }
                                        whereAll.map(it => {
                                            if (it.name == 'refParent.id') {
                                                it.value = modelRef.refLabTopic.id;
                                            }
                                            if (it.name == 'refLabType.key') {
                                                it.value.filter(labType => labType == 'labPhysic');
                                            }
                                        });
                                    },
                                    afterSelect: () => {
                                        createRulesAnalysisTopicInput({ useForm, itemsKey });
                                    }
                                });
                            },
                            disabledSearch: ['refParent.id']
                        });
                    }
                },
                options: { text: i18n.global.t('model.samplingProductAnalysisTopicInput.modelName') }
            })
        }),
        visible: () => has({ menuContext, key: 'canCreate' })
    });

     data.rowActions.push({
         visible: () => has({ menuContext, key: 'canEdit' }),
         bind: { class: 'btn-danger', size: 'small', icon: () => <CIcon file="delete.svg"></CIcon> },
         text: () => i18n.global.t('button.cancel'),
         onClick: ({ record }) => {
             Modal.confirm({
                 title: i18n.global.t('components.table.operatorAndPagination.youAreWant', { text: i18n.global.t('button.delete') }),
                 autoFocusButton: 'cancel',
                 okType: 'danger',
                 onOk: () => {
                     clearRulesStartsWith({ useForm, key: itemsKey });
                     onClickDeleteAllClient({
                         rowSelection: { selectedRows: [record] },
                         items: parent[`${itemsKey}`]
                     });
                 }
             });
         }
     });
     // data.rowClassName = (record) => (record.isActive === false ? "bg-inactive" : "");
     if (props.parent[`${itemsKey}`].length == 0) {
         fetchData({ props, data })
             .then(page => {
                 emit('loadedData', page)
                 props.parent[`${itemsKey}`].push(...page.data);
                 createRulesAnalysisTopicInput({ useForm, itemsKey })
             })
     }


};

